import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_carousel = _resolveComponent("base-carousel")

  return (_ctx.localItems.length > 0)
    ? (_openBlock(), _createBlock(_component_base_carousel, {
        key: 0,
        autoplay: true,
        onChange: $options.onChange
      }, {
        default: _withCtx(({}) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.images, (image) => {
            return (_openBlock(), _createElementBlock("div", {
              key: image.key,
              class: _normalizeClass(['gfu-creator-banner__slide', { 'is-active': image.isActive}]),
              style: _normalizeStyle(`background-image: url(${image.imageUrl});`),
              "data-qa": `creator-banner-slider-image:${image.key}`
            }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        nav: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", null, null, -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onChange"]))
    : _createCommentVNode("v-if", true)
}